import React, { useCallback } from "react";
import SeriesSlider from "./SeriesSlider";

const SeriesListing = (props) => {
    let hasOtherSelectedFilter = props.filterGroups?.find((x) => x.id !== "SeriesCodes" && x.items.find((y) => y.selected === true));

    const onClick = useCallback(
        (series) => {
            const items = props.items;
            const savedValue = series.selected;

            items.forEach((item) => {
                item.selected = false;
            });

            if (savedValue === undefined || savedValue === false) {
                series.selected = true;
                items.filter((x) => x.code === series.code)[0].selected = true;
            } else {
                series.selected = false;
                items.filter((x) => x.code === series.code)[0].selected = false;
            }
            props.onItemSelected(series);
        },
        [props.items, props.onItemSelected]
    );

    return (
        <>
            <SeriesSlider
                items={
                    hasOtherSelectedFilter
                        ? props.items.filter(item =>
                            props.ancestorIds?.includes(item.contentLink.split("__")[0])
                        )
                        : props.items
                }
                filterGroups={props.filterGroups}
                onClick={onClick}
                showHideSeriesData={props.showHideSeriesData}
                showInlineSeriesData={props.showInlineSeriesData}
                seriesDataSelectedSeries={props.seriesDataSelectedSeries}
            />
        </>

    );
};

export default SeriesListing;
